import React from 'react';
import {Image} from 'launchpad'

export default class Hero extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Image name={this.props.id || this.props.name} prefix='heroes' className={'hero ' + (this.props.className || '') + (this.props.half ? ' half': '')} alwaysEdit={this.props.alwaysEdit} useEditIcon >
          {this.props.children}
      </Image>
    );
  }
}
